<template>
    <div class="page5-container">
        <div class="page5-content-container" v-if="(isWritingMessage && !isMobile()) || isMobile()">
            <div v-if="isMobile()" class="categories-container no-scrollbar">
                <p class="title">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559">
                    Filter by:
                </p>
                <div class="buttons-container">
                    <button 
                        v-for="occasion of occasionFilters.slice(0, 3)" 
                        :key="occasion"
                        @click="setSelectedOccasion(occasion)" 
                        class="step-button"
                        :class="selectedCardsOccasions.includes(occasion) ? 'selected' : ''"
                    > 
                    {{occasion}}
                    </button>
                </div>
                <button class="happybox-button white border more" @click="showFilters()">More Filters</button>
            </div>
            <div class="content-header">
                <div v-if="steps[2] && steps[2].html" class="title" v-html="steps[2].html"></div>
                <p v-else class="title">Step 3: Select a Card</p>
                <p class="subtitle">We'll handwrite your message for you, <br/> or you can <span @click="skipCard()">SKIP THE CARD HERE</span></p>
            </div>
            <div id="header-container" class="header-container">
                <div class="placeholder-recommendations">
                    <div class="buttons-container">
                        <button class="happybox-button white border" :class="!selectedCardsOccasions.includes('View All') ? 'selected' : ''" @click="showFilters()">
                            <img v-if="!selectedCardsOccasions.includes('View All')" class="purple" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
                            <img v-else class="normal" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"/>
                            Filters 
                            <span v-if="!selectedCardsOccasions.includes('View All')">({{ selectedCardsOccasions.length }})</span>
                        </button>
                    </div>
                </div>
            </div>
            <ul class="cards-container">
                <p v-if="!selectedCardsOccasions.includes('View All')" class="other-gifts">{{ selectedCardsOccasions.join(", ") }}</p>
                <p class="over-budget" v-if="sortedCards.length == 0">You're currently over your allotted budget. <br/> Please remove some items from your gift to be able to add more items.</p>
                <li v-for="card in sortedCards" :key="card.id">
                    <div class="card-container">
                        <div>
                            <div class="main-image-container" :class="(selectedCard && selectedCard.id == card.id) ? 'selected' : '' ">
                                <span v-if="card.corporate" class="secondary-badge">Inventory: {{getCardInventory(card)}}</span>
                                <img v-if="selectedCard && selectedCard.id == card.id" class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                                <img @click="selectCard(card)" class="main-image lazyload" width="280" height="280" loading="lazy" :src="card | getProductImage">
                            </div>
                            <p class="card-title">{{card.title}}</p>
                            <p class="card-price">{{card | moneyFormat}}</p>
                        </div>
                        <button v-if="card.id == 7148612419749" @click="selectCard(card)" class="happybox-button white border">Skip Card</button>
                        <button v-else-if="selectedCard && selectedCard.id == card.id && buttonDisabled" @click="selectCard(card)" class="happybox-button green border">Write message</button>
                        <button v-else-if="selectedCard && selectedCard.id == card.id && !buttonDisabled" @click="openCart()" class="happybox-button green border">Next ></button>
                        <button v-else @click="selectCard(card)" class="happybox-button white border">Select Design</button>
                        
                    </div>
                </li>
            </ul>
        </div>
        <div v-else-if="!isMobile()" class="write-message-container">
            <div class="card-image-container">
                <img class="lazyload" width="280" height="280" loading="lazy" :src="selectedCard | getProductImage">
                <div>
                    <p class="card-title">{{selectedCard.title}}</p>
                    <button  v-if="!isMobile()" class="blue-span" @click="closeCard">Change Card</button>
                    <p v-if="isMobile()" class="purple-span">Type in your message below. One of our team members will hand write your message and pack it in with your box.</p>
                </div>
            </div>
            <div class="write-container" :class="isBlankMessage ? 'blank' : ''">
                <div v-if="noMessageCurrentCard === false">
                    <p v-if="!isMobile()" class="purple-span">Type in your message below. One of our team members will hand write your message and pack it in with your box.</p>
                    <p v-if="remainingCharacters < 0" class="red-span">Your message has a limit of 200 characters. Keep it short and sweet!</p>
                    <p></p>
                    <div class="blank-card-container">
                        <input v-model="isBlankMessage" v-on:change="changeBlankMessage()" id="blankCard" type="checkbox">
                        <label for="blankCard">Click here if you want your card blank</label>
                    </div>
                </div>
                <div v-else>
                    <p class="no-message">This card comes digitally printed.</p>
                </div>
                <div v-if="!isBlankMessage" class="form-container">
                    <div class="message-container">
                        <label for="message">Your Message:</label>
                        <textarea placeholder="Start typing here..." maxlength="200" v-model="message" cols="30" rows="3" id="message"></textarea>
                    </div>
                    <div class="from-container">
                        <label for="from">From:</label>
                        <input placeholder="Your Name" maxlength="200" v-model="from" id="from" type="text">
                        <p class="purple-span" :class="remainingCharacters == 0 ? 'red' : ''">Characters Remaining {{remainingCharacters}}</p>
                    </div>
                </div>
                <button class="date-button" @click="function(){openCalendar = !openCalendar}">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/calendar.svg?v=1670856557"/>
                    {{dateButton}}
                    <span class="arrow down"></span>
                </button>
                <date-picker 
                    id="datepicker"
                    v-model="selectedDate"
                    format="MM-DD-YYYY"
                    type="date" 
                    valueType="timestamp"
                    :default-value="minDate"
                    :disabled-date="disabledDates"
                    :editable="false"
                    :open.sync="openCalendar"
                    @close="checkDate"
                    >
                    <template v-slot:footer="{ emit }">
                    <div style="text-align: right">
                        <button class="mx-btn mx-btn-text" @click="clearDate(emit)">
                            Clear
                        </button>
                    </div>
                    </template>
                </date-picker>
                <p @click="() => {this.messageModal = true}" v-if="messages && messages.length > 0" class="purple-link">See Curated Messages!</p>
                <button v-if="!isMobile()" :disabled="buttonDisabled" @click="openCart()" class="happybox-button green border" :class="isLoading ? 'isLoading' :'' ">{{buttonText}}</button>
            </div>
        </div>
        <div @click="closeCard" class="write-message-page" :class="!isWritingMessage && isMobile() ? 'expanded' : 'collapsed'">
            <div v-if="!isWritingMessage && isMobile()" v-on:click.stop class="write-message-container">
                <div v-if="isMobile()" @touchstart="dragStart" @touchend="dragEnd" class="separator-container">
                    <p>Time to write your card message!</p>
                </div>
                <div class="card-image-container">
                    <img :src="selectedCard | getProductImage">
                    <div>
                        <p class="card-title">{{selectedCard.title}}</p>
                        <p v-if="isMobile()" class="purple-span">Type in your message below. One of our team members will hand write your message and pack it in with your box.</p>
                    </div>
                </div>
                <div class="write-container" :class="isBlankMessage ? 'blank' : ''">
                    <div>
                        <p v-if="!isMobile()" class="purple-span">Type in your message below. One of our team members will hand write your message and pack it in with your box.</p>
                        <div class="blank-card-container">
                            <input v-model="isBlankMessage" v-on:change="changeBlankMessage()" id="blankCard" type="checkbox">
                            <label for="blankCard">Click here if you want your card blank</label>
                        </div>
                    </div>
                    <div v-if="!isBlankMessage" class="form-container">
                        <div class="message-container">
                            <label for="message">Your Message:</label>
                            <textarea placeholder="Start typing here..." maxlength="110" v-model="message" cols="30" rows="3" id="message"></textarea>
                        </div>
                        <div class="from-container">
                            <label for="from">From:</label>
                            <input placeholder="Your Name" maxlength="110" v-model="from" id="from" type="text">
                            <p class="purple-span" :class="remainingCharacters == 0 ? 'red' : ''">Characters Remaining {{remainingCharacters}}</p>
                        </div>
                    </div>
                    <button class="happybox-button yellow" style="margin-bottom:5%;" @click="function(){openCalendar = !openCalendar}">{{dateButton}}</button>
                    <date-picker 
                        id="datepicker"
                        v-model="selectedDate"
                        format="MM-DD-YYYY"
                        type="date" 
                        valueType="timestamp"
                        :default-value="minDate"
                        :disabled-date="disabledDates"
                        :editable="false"
                        :open.sync="openCalendar"
                        @close="checkDate"
                    >
                        <template v-slot:footer="{ emit }">
                        <div style="text-align: right">
                            <button class="mx-btn mx-btn-text" @click="clearDate(emit)">
                                Clear
                            </button>
                        </div>
                        </template>
                    </date-picker>
                    <div class="complete-box">
                        <button :disabled="buttonDisabled" @click="bundle" class="happybox-button green border" :class="isLoading ? 'isLoading' :'' ">{{buttonText}}</button>
                    </div>
                </div>
            </div>
        </div>
        <OOSPopUp
            v-if="oosIsActive"
            :oosProducts="noStockItems" 
            :firstStateProducts="currentStateSelectedAddons"
            :fromSavedCart="true"
            :fromCurated="false"
            @goback="goToAddonSelection()"
            @continuesaved="bundle()"
            @continuecurated="bundle()"
        />
        <div class="global-spinner-container" v-if="isLoading && cardSkipped">
            <div class="global-spinner"></div>
        </div>
        <CardFilter @closefilter="showFilters()" :occasionFilters="occasionFilters" v-if="filterIsShown"/>
        <div @click="() => {this.messageModal = false}" v-if="messageModal" class="message-modal">
            <div v-on:click.stop class="modal-container">
                <img @click="() => {this.messageModal = false}" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x" class="x">
                <p class="title">Pick one of the curated messages</p>
                <div class="input-container" v-for="message in messages">
                    <input type="radio" :value="message" v-model="selectedMessage"/>
                    <label for="huey">{{message}}</label>
                </div>

                <div class="buttons">
                    <button class="happybox-button white border" @click="() => {this.messageModal = false}">Cancel</button>
                    <button class="happybox-button green border" :disabled="!selectedMessage" @click="() => {this.message = this.selectedMessage;this.messageModal = false;}">Apply</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import smoothReflow from 'vue-smooth-reflow'
import { mapGetters, mapActions } from 'vuex';
import axios from "axios";
import OOSPopUp from './OOSPopUp.vue'
import CardFilter from './CardFilter.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    mixins: [smoothReflow],
    components:{
        OOSPopUp,
        CardFilter,
        DatePicker
    },
    props:{
        currentPage: Number,
        user: String,
        sender: String,
    },
    data(){
        return{
            messageType: 'handwritten',
            isBlankMessage: false,
            from: '',
            message: '',
            noStockItems: [],
            openOOS: false,
            currentStateSelectedAddons: [],
            startingY: 0,
            isLoading: false,
            isSticking: false,
            isChanging: false,
            cardSkipped: false,
            filterIsShown: false,
            selectedDate: null,
            openCalendar: false,
            messageModal: false,
            selectedMessage: null,
        }
    },
    computed: {
        ...mapGetters([
            'cardProducts',
            'savedCardProduct',
            'selectedBoxProduct',
            'selectedAddonProducts',
            'boxName',
            'feeProduct',
            'boxQty',
            'boxProducts',
            'individualProducts',
            'savedKey',
            'corpName',
            'currentBudget',
            'budget',
            'messages',
            'submittedInputs',
            'hasHPFee',
            'steps',
            'freeShipping',
        ]),
        selectedCardsOccasions: {
            get(){ return this.$store.state.selectedCardsOccasions},
            set(value){this.$store.commit('setSelectedCardsOccasions', value )}
        },
        selectedCardsOccasionsMobile: {
            get(){ return this.$store.state.selectedCardsOccasionsMobile},
            set(value){this.$store.commit('setSelectedCardsOccasionsMobile', value )}
        },
        selectedCard:{
            get(){ return this.$store.state.selectedCardProduct},
            set(value){this.$store.commit('updateSelectedCardProduct', value )}
        },
        breadcrumbText(){
            return `All products > ${this.selectedCardsOccasions}`
        },
        isWritingMessage(){
            return !(this.messageType === 'handwritten' && this.currentPage == 4)
        },
        remainingCharacters(){
            var currentMessage = this.from + this.message;
            var currentRemainingCharacters = 200 - currentMessage.length;
            
            return currentRemainingCharacters;
        },
        buttonDisabled(){
            if((this.isBlankMessage == false && this.message.length > 0 && this.remainingCharacters >= 0) || this.isBlankMessage == true){
                return false;
            }

            return true
        },
        bundleProducts(){
            var bundleProducts = [];
            bundleProducts.push(this.selectedAddonProducts);
            bundleProducts.push(this.selectedBoxProduct);
            bundleProducts.push(this.selectedCard);

            return bundleProducts.flat();
        },
        oosIsActive(){
            return this.openOOS && this.noStockItems.length > 0;
        },
        buttonText(){
            return this.isLoading ? "loading..." : "Next"
        },
        sortedCards(){
            let copyCards = JSON.parse(JSON.stringify(this.cardProducts));
            copyCards = copyCards.filter(x => (parseFloat(x.variants[0].price) + this.currentBudget) <= this.budget);
            //filter cards for inventory
            
            if(!this.selectedCardsOccasions.includes("View All")){
                return copyCards.sort((a,b) => {
                    let sortA = a.tags.split(",").some(x=> this.selectedCardsOccasions.some(y => x.includes(y)));
                    let sortB = b.tags.split(",").some(x=> this.selectedCardsOccasions.some(y => x.includes(y)));
                    if(sortA && sortB)
                        return 0
                    else if(sortA && !sortB)
                        return -1
                    else 
                        return 1
                });
                
            }
            return copyCards;
        },
        filteredCards(){
            let cards = [];
            if(this.selectedCardsOccasions && this.selectedCardsOccasions.length > 0){
                for(let [i, occasion] of this.selectedCardsOccasions.entries()){
                    let current = this.cardProducts.filter(x => x.tags.includes(occasion));
                    if(current.length > 0){
                        cards.push({occasion: occasion,products: current});
                    }
                }
            }

            return cards;
        },
        occasionFilters(){
            let tags = this.cardProducts.flatMap(x => x.tags.split(",").filter(y => y.includes("Filter_Occasion_")));
            let uniqueOccasion = tags.flatMap(x => x.replace("Filter_Occasion_","").trim());
            uniqueOccasion.unshift("View All");
            return [...new Set(uniqueOccasion)];
        },
        minDate(){
            let minDate = new Date();
            let numToAdd = 1;
            for (let i = 1; i <= numToAdd; i++) {
                minDate.setDate(minDate.getDate() + 1);
                if (minDate.getDay() === 6) {
                    minDate.setDate(minDate.getDate() + 2);
                }
                else if (minDate.getDay() === 0) {
                    minDate.setDate(minDate.getDate() + 1);
                }
            }
            return minDate;
        },
        maxDate(){
            let maxDate = new Date();
            maxDate = new Date(maxDate.setMonth(maxDate.getMonth()+6));
            return maxDate;
        },
        dateButton(){
            if(!this.selectedDate){
                return "Select Shipping Date"
            }
            else {
                return this.rangeDate;
            }
        },
        rangeDate(){
            if(this.selectedDate){
                let date = new Date(this.selectedDate);
                let maxDate = new Date(date.setDate(date.getDate() + 4))
                return new Date(this.selectedDate).toLocaleDateString("en-US") + " - " + maxDate.toLocaleDateString("en-US");
            }
            return ""
        },
        noMessageCurrentCard() {
            return this.selectedCard?.tags.includes("no_message") || false;
        },
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768;
        },
        async getCurrentProducts(){
            return await axios
                .get('https://api.happyboxstore.com/api/bundle/getGiftProducts')
                .catch((err) => {
                console.log(err);
                });
        },
        hasMinimum(card){
            return card.tags.includes("QTYMIN");
        },
        cardMinimum(card){
            let tags = card.tags.split(",");
            if(tags.some(y => y.includes("QTYMIN"))){
                let minTag = tags.find(x => x.includes("QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];

                    return minTag;
                }

                return 0
            }

            return 0;
        },
        selectCard(card){
            if(this.hasMinimum(card) && this.boxQty < this.cardMinimum(card)){
                return;
            }
            this.selectedCard = card;
            if(card.tags.includes("no_message"))
                this.isBlankMessage = true;
            if(card.id == 7148612419749){
                this.cardSkipped = true;
                this.isBlankMessage = true;
                this.openCart();
                return;
            }
            this.$emit("changepage", true);
        },
        closeCard(){
            this.$emit("changepage", false);
        },
        changeBlankMessage(){
            if(this.isBlankMessage){
                this.from = '';
                this.message = '';
            }
        },
        openCart(){
            this.$emit("opencart");
        },
        async bundle(){
            //check for OOS Products
            if(this.isLoading)
                return
            this.isLoading = true;
            this.noStockItems = [];
            let currentProducts = await this.getCurrentProducts();
            currentProducts = currentProducts.data.filter(x => x.product_type == "Gift");
            for (const product of this.selectedAddonProducts) {
                if(product.tags.some(x => x == `Filter_Category_${this.corpName} Gifts`))
                    continue
                
                if (product.id === 5857068220581) { // If it's handpacking fee, skip iteration
                    continue;
                }
                const productDataResponse = currentProducts.find(x => x.id == product.id);
                const productData = productDataResponse === undefined ? null : productDataResponse;
                if (!productData || productData.variants.length === 0) {
                    this.noStockItems.push(product);
                    continue;
                }
                productData.variants = productData.variants.map((variant) =>{
                    variant.inventory_quantity = variant.inventory_policy == "continue" ? 9999 : variant.inventory_quantity
                    return variant;
                })
                let { inventory_quantity } = productData.variants.find( x=> product.variants[0].id == x.id);
                const productHasNoStock = inventory_quantity - product.quantity < 0;
                if (productHasNoStock) {
                    this.noStockItems.push(product);
                }
            }

            if (this.noStockItems.length > 0) {
                this.openOOS = true;
                this.currentStateSelectedAddons = JSON.parse(JSON.stringify(this.selectedAddonProducts));
                return;
            }

            let uniqueKey = Date.now();

            var properties = {};
            properties = await this.getGiftshipProperties();
            properties["Box"] = this.selectedBoxProduct.title;
            properties["Card"] = this.selectedCard.title;
            properties["Message"] = this.message;
            properties["From"] = this.from;
            properties["LeaveCardBlank"] = this.isBlankMessage;
            properties["_uniqueKey"] =  uniqueKey;
            properties["boxName"] = this.boxName;
            properties["_capacity"] = this.selectedBoxProduct.variants[0].option1;
            properties["CorporateOrder"] = true;
            properties["CorporateName"] = this.user;
            properties["_sender"] = this.sender;
            let path = window.location.pathname.split("/");
            properties["_storefront"] = path[path.length - 1];
            if(!this.hasHPFee)
                properties["_no_fee"] = true;
            if(this.freeShipping){
                properties["_free_shipping"] = true;
            }

            if(this.selectedDate){
                properties["Shipping Date"] = this.rangeDate;
            }

            for (const [key, value] of Object.entries(this.submittedInputs)) {
                properties[`_Custom_Input_${key}`] = value;
            }
            //add total order value
            let totalValue = 0;

            this.bundleProducts.forEach((line, index) => {
                let price = 0;
                if(line.variants[0].value_price)
                    price = parseFloat(line.variants[0].value_price);
                else if (typeof line.variants[0].price === 'string' || line.variants[0].price instanceof String){
                    price = parseFloat(line.variants[0].price)
                }
                else {
                    price = line.variants[0].price / 100;
                }
                totalValue += (price * (line.quantity || 1));
            });
            properties[`_Custom_Input_Total Order Value`] = totalValue;

            const box = this.boxProducts.find(x => this.selectedBoxProduct.id == x.id);
            if(this.selectedAddonProducts.some(x => x.tags.includes("XLTRIGGER")) || (parseInt(this.selectedBoxProduct.variants[0].option1) > 200)){
                properties["XL"] = true;
            }



            let qtyMinProducts = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("QTYMIN_")));

            if(qtyMinProducts.length > 0){
                let qtyMins = qtyMinProducts.map( (x) => {
                    let qtyMinTag = x.tags.find(x => x.includes("QTYMIN_"));
                    qtyMinTag = qtyMinTag.split("_");
                    qtyMinTag = qtyMinTag[qtyMinTag.length - 1];

                    return parseInt(qtyMinTag);
                })

                properties["qtyMin"] = Math.max(...qtyMins);
            }
            

            var imagesUrls = this.selectedAddonProducts.map((x) => {
                if(x.properties){
                    let hasImage = x.properties.find(y => y.name == "_showImage");
                    if(hasImage){
                        return hasImage.value;
                    }
                    let variant = x.variants.find(y => y.title != "Default Title");
                    if(variant && variant.image_id){
                        let image = x.images.find(y => y.id = variant.image_id);
                        if(image)
                            return image.src;
                    }
                }
                return (x.images.length > 0) ? x.images[x.images.length - 1].src : ''
            })
            properties["productImages"] = imagesUrls;

            var items = "";
            this.selectedAddonProducts.forEach((product, i) => {
                var propertyId = "Item_" + (i + 1);
                var title = `${product.quantity}x ${product.title}`
                if(product.variants[0].title != "Default Title"){
                    title += ` - ${(product.variants[0].title)}`
                }
                properties[propertyId] = title;
                if((i + 1) == this.selectedAddonProducts.length){
                    items += ` ${title}`
                }else{
                    items += ` ${title},`
                }
            });
            properties["Items"] = items;
            if(this.selectedAddonProducts.some(x => x.variants.some(y => y.sku && y.sku.toLowerCase().includes("ondemand")))){
                properties["onDemand"] = true;
            }
            let multipleSizes = false;
            let productProperties = this.selectedAddonProducts.filter(x => x.properties);
            let bulkItems = [];
            for(let product of productProperties){
                for(let property of product.properties){
                    if(property.name == "_sizes")
                        multipleSizes = true;
                    else
                        properties[property.name] = property.value;
                } 

            }
            properties["_gs_item_properties"] = JSON.stringify(properties);
            localStorage.removeItem("totalAddons");
            localStorage.removeItem("openBuilder");
            let item = {
                id: 41663054184613,
                quantity: this.boxQty,
                properties: properties,
            }
            if(this.individualProducts.length > 0){
                for(let product of this.individualProducts){
                    let hasSizes = false;
                    let individualProperties = {};
                    individualProperties["_uniqueKey"] = uniqueKey
                    for(let property of product.properties){
                        if(property.name == "_sizes")
                            hasSizes = true;
                        else
                            individualProperties[property.name] = property.value;
                    }
                    if(hasSizes){
                        let sizes =  product.properties.find(x => x.name == "_sizes")
                        if(sizes){
                            let sizeItems = sizes.value.map((x) =>{
                                let sizeItem = {
                                    id: product.variants[0].id,
                                    quantity: x.qty,
                                    properties: individualProperties,
                                }

                                sizeItem.properties[`${product.title}_size`] = x.name;

                                return sizeItem;
                            })
                            bulkItems = bulkItems.concat(sizeItems);
                        }
                    }
                    else{
                        bulkItems.push({
                            id: product.variants[0].id,
                            quantity: product.quantity,
                            properties: individualProperties,
                        });
                    }
                }
            }
            if(multipleSizes){
                for(let product of productProperties){
                    let sizes =  product.properties.find(x => x.name == "_sizes")
                    if(sizes){
                        let sizeItems = sizes.value.map((x) =>{
                            let sizeItem = {
                                id: 41663054184613,
                                quantity: x.qty,
                                properties: Object.assign({}, properties),
                            }

                            sizeItem.properties[`${product.title}_size`] = x.name;
                            sizeItem.properties["boxName"] = `${this.boxName} - ${x.name}`;

                            return sizeItem;
                        })
                        bulkItems = bulkItems.concat(sizeItems);
                    }
                }
                
            }
            else
                bulkItems.push(item);
            
            if(bulkItems.length > 1)
                this.ajaxAddBulk(bulkItems);
            else
                this.ajaxAddCart(item);
        },
        ajaxAddCart(item) {
            let formData = this.objectToFormData(item);
            axios
            .post("/cart/add.js", formData)
            .then((response) => {
                localStorage.setItem("cartDate",Date.now());
                localStorage.setItem('finishedBox',true);
                this.cleanSavedKey();
            })
            .catch((err) => {
                console.log(err);
            });
        },
        async ajaxAddBulk(items){
            for(let item of items){
                let formData = this.objectToFormData(item);
                await axios.post("/cart/add.js",formData)
            }
            localStorage.setItem("cartDate",Date.now());
            localStorage.setItem('finishedBox',true);
            await this.cleanSavedKey();
        },
        async cleanSavedKey(){
            location.href = '/cart'
        },
        objectToFormData(currentItem) {
            const form_data = new FormData();

            for (const key in currentItem) {
                if (key === "properties" && currentItem[key] && typeof currentItem[key] === "object") {
                const props = currentItem[key];

                for (const pKey in props) {
                    const value = props[pKey];

                    // special file handling
                    if (pKey === "gif") {
                    if (this.file && this.fileSelected) {
                        form_data.append(`properties[${pKey}]`, this.file);
                    }
                    continue;
                    }

                    if (pKey === "logo") {
                    if (this.logo && this.logoSelected) {
                        form_data.append(`properties[${pKey}]`, this.logo);
                    }
                    continue;
                    }

                    // arrays -> multiple fields: properties[pKey][]
                    if (Array.isArray(value)) {
                    value.forEach(v => {
                        form_data.append(`properties[${pKey}][]`, v);
                    });
                    } else if (value && typeof value === "object") {
                    // plain objects -> JSON
                    form_data.append(`properties[${pKey}]`, JSON.stringify(value));
                    } else {
                    // scalars
                    form_data.append(`properties[${pKey}]`, value ?? "");
                    }
                }
                } else {
                const value = currentItem[key];

                // if you ever have arrays outside properties, also send them as multiple fields
                if (Array.isArray(value)) {
                    value.forEach(v => {
                    form_data.append(`${key}[]`, v);
                    });
                } else if (value && typeof value === "object") {
                    form_data.append(key, JSON.stringify(value));
                } else {
                    form_data.append(key, value ?? "");
                }
                }
            }

            return form_data;
        },
        async getGiftshipProperties(){
            var products = this.bundleProducts;
            if(this.hasHPFee)
                products.push(this.feeProduct);
            var titles = products.map((x) => {
                return x.title + " - " + x.variants[0].title + " - Quantity: " + (x.quantity ? x.quantity : 1); 
            })
            var ids = products.map(x => x.variants[0].id);
            var prices = products.map((x) => {
                let currentPrice = 0;
                let quantity = x.quantity ? x.quantity : 1;
                let price =  x.variants[0].true_price || x.variants[0].price
                if(typeof price === 'string' || price instanceof String)
                    currentPrice = parseInt(price.replaceAll(".",""));
                else 
                    currentPrice = price;
                return currentPrice * quantity;
            });
            var quantities = products.map(x => x.quantity ? x.quantity : 1);
            var properties = {};
            properties["_gs_bundle_contents"] = titles;
            properties["_gs_bundle_ids"] = ids;
            properties["_gs_bundle_prices"] = prices;
            properties["_gs_bundle_quantities"] = quantities;
            properties["_gs_bundle_discount"] = 0;

            return properties;
        },
        async getEmptyCard(){
            return await axios
            .get("/products/no-card.js")
            .catch((err) => {
                console.log(err);
            });
        },
        async skipCard(){
            const noCard = await this.getEmptyCard();
            noCard.data.images = noCard.data.images.map((x) =>{
                return {src:x}
            });
            this.selectedCard = noCard.data;
            this.from = "";
            this.message = "",
            this.cardSkipped = true;
            this.openCart();
            if(this.isMobile()){
                await this.bundle();
            }
        },
        goToAddonSelection(){
            this.$emit("gotoaddonselection");
        },
        dragStart(event){
            this.startingY = event.touches[0].screenY;
        },
        dragEnd(event){
            if((event.changedTouches[0].screenY - this.startingY) > 100)
            this.closeCard();
        },
        setSelectedOccasion(value){
            const pageContainer = document.getElementById('PageContainer');
            if (pageContainer) pageContainer.scrollTop = 0;
            this.selectedCardsOccasions = value;
            this.selectedCardsOccasionsMobile = value;
        },
        showFilters(){
            this.filterIsShown = !this.filterIsShown;
        },
        disabledDates(date){
            return date < this.minDate || date > this.maxDate;
        },
        checkDate(){
            if(!this.selectedDate || this.selectedDate == ""){
                this.clearDate();
            }
        },
        clearDate(){
            this.selectedDate = null;
            this.openCalendar = false;
        },
        getCardInventory(card){
            return card.variants.reduce((acc, curr) => acc + curr.inventory_quantity, 0);
        },
    },
    mounted(){
    },
    destroy() {
    }

}
</script>

<style scoped>

.blue-span{
    align-items: center;
    text-decoration-line: underline;
    color: #5048E5 !important;
    font-size: 1vw;
}

.purple-span{
    font-size: 1vw;
    color: gray;
}

.no-message{
    font-size: 1.5vw;
    margin-bottom: 1rem;
}

.purple-span.red{
    color: red;
}

.red-span{
    font-size: 1.15vw;
    color: red;
}

.page5-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0% 10%;
}
.main-title{
    color: #0F0C38;
    font-family: 'moret',sans-serif !important;
    font-size: 2.5vw;
    margin-top: 2%;
    font-weight: 300;
}

.main-subtitle{
    font-size: 1.2vw;
    color: #3F3D60;
}

.cards-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: unset;
    gap: 10px 2.66%;
}

.cards-container li{
    width: 23%;
}

.card-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5%;
}

.card-title{
    font-size: 1.1vw;
    font-weight: bold;
    padding-top: 5%;
    width: 100%;
}

.card-price{
    font-size: 1.1vw;
    line-height: 1.2;
    width: 100%;
}

.card-desc{
    color: #A186C4 !important;
    font-size: 1vw;
    line-height: 1.4;
    padding-bottom: 10%;
}

.card-type-select{
    background-color: #f3f4f6;
    padding: 5px;
    display: flex;
    border-radius: 50px;
    font-size: 12px;
    text-transform: uppercase;
    margin-top: 2%;
}

.card-type-select .option{
    cursor: pointer;
    padding: 9px 13px;
    border-radius: 40px;
    color: #190245;
    font-weight: 700;
}

.card-type-select .option.selected {
    background-color: white;
    color: #190245;
    padding: 9px 13px;
    border-radius: 40px;
    font-weight: 700;
    border: 1px solid #E5E7EB;
    box-shadow: 0 1px 2px #1f293714;
}

.skip-card{
    color: #190245;
    font-weight: 700;
    font-size: 0.8rem;
    margin-top: 5px;
    text-decoration: underline;
    cursor: pointer;
}

/* Write message component START */
.write-message-container{
    width: 70%;
    display: flex;
    flex-direction: row;
    margin: 2% 0%;
    padding: 2% 1%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    justify-content: space-between;
}

.card-image-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 30%;
}

.card-image-container img{
    width: 100%;
    height: auto;
}

.write-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 65%;
    min-height: 100%;
}

.write-container.blank{
    gap: 15px;
}

.form-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.from-container,.message-container{
    display: flex;
    flex-direction: column;
    width: 100%;
}

.from-container label,.message-container label{
    font-weight: bold;
    color: #0F0C38;
    font-size: 1vw;
}

.from-container input{
    width: 40%;
}

.from-container .purple-span{
    padding: 2% 0%;
}

.write-container textarea{
    width: 90%;
    min-height: 20vh;
}

.write-container textarea,.write-container input{
    background: #FFFFFF !important;
    border: 1px solid #E5E7EB !important;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08) !important;
    border-radius: 4px !important;
    color: #0F0C38;
    height: unset !important;
    font-size: 1.2vw;
    accent-color: black;
}

.write-container textarea:focus-visible,.write-container input:focus-visible{
    border: 1px solid #E5E7EB !important;;
    outline: none;
}

.blank-card-container{
    display: flex;
    align-items: center;
    font-size: 1.2vw;
    color: #0f0c38;
    margin: 1% 0%
}

.main-image-container{
    border: 1px solid #F5EEFE;
    width: 100%;
    border-radius: 4px;
    position: relative;
    display: flex;
}

.main-image-container.selected{
    border: 1px solid #16A34A;
}

.green-check{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.main-image{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
}
/* Write message component END */

.categories-container{
    width: 100vw;
    margin-left: -10vw;
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 3% 2%;
    box-shadow: 0px 1px 0px 0px #0003;
    position: sticky;
    top: -2px;
    background-color: white;
    z-index: 1;
}

.categories-container .buttons-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 3vw;
    line-height: 1.3;
    color: #7A7991;
    padding: 2%;
    border-radius: 20px;
    border: 1px solid lightgray;
}

.categories-container .buttons-container button.selected{
    color: white;
    background-color: #0F0C38;
}

.categories-container .title{
    flex: 2;
    font-size: 3vw;
    display: flex;
    gap: 5px;
    font-weight: bold;
    align-items: center;
}

.categories-container .title img{
    width: 15px;
}

.categories-container .buttons-container{
    flex: 4;
}

.categories-container .more{
    flex: 2;
    padding: unset;
}

.isLoading{
    animation: colorChange 2.5s ease-in-out infinite;
}

.quick-tags-container{
        background: #FFFFFF;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        padding: 8px 8px 8px 8px;
        align-items: center;
        gap: 5px;
    }

    .quick-tag{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 4px 6px 4px 8px;
        gap: 4px;
        background: #FFFFFF;
        border: 1px solid #F3EEFA;
        border-radius: 4px;
    }

    .quick-tag p{
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
        font-size: 1vw;
        line-height: 1.3;
        color: #0F0C38;
    }

    .quick-tag span{
        color: #6B7280;
        font-size: 1.2vw;
        font-weight: bold;
        cursor: pointer;
    }

    .page5-header{
        text-align: center;
    }

    .page5-content-container{
        width: 100%;
    }

@keyframes colorChange {
    33% {
        background-color: #b7bfff;
    }


    66% {
        background-color: #ffc8c4;
    }

    100%{
        background-color: #ffeeda;
    }
}

.content-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 0.1rem
}

.content-header .title{
    font-size: 2vw;
    line-height: .8;
    font-weight: bold;
    margin: unset;
    margin-bottom: 1rem;
}

.content-header .subtitle{
    font-size: 1.3vw;
    line-height: 1.2;
    text-align: center;
}

.content-header .subtitle span{
    cursor: pointer;
    text-decoration: underline;
}

.header-container{
    background-color: white;
    width: 100%;
    padding: 0% 10%;
}

.header-container.sticky{
    box-shadow: -2px 0px 1px 2px rgba(0,0,0,0.2);
}

.leave-builder,.breadcrumb{
    font-size: 1vw;
    line-height: 1.5;
    letter-spacing: .08em;
    text-transform: uppercase;
    font-weight: 700;
    text-align: center;
    display: flex;
    align-items: center;
    flex: 2;
    z-index: 1;
    cursor: pointer;
}

.header-container .buttons-container{
    display: flex;
    gap: 5%;
    flex: 1;
}

.header-container .buttons-container button{
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 0.5% 3%;
}

.header-container .buttons-container button img{
    width: 15px;
    padding: unset
}

.header-container .buttons-container button.selected{
    color: #a01adb;
    font-weight: 700;
    border: 1px solid #a01adb;
}

.header-container .buttons-container button.selected span{
    color: #a01adb;
    font-weight: 700;
}

.leave-builder{
    justify-content: flex-end;
    width: 37.5%;
    gap: 2px;
}

.leave-builder span{
    line-height: 0;
}

.leave-builder img{
    width: 15px;
    padding: unset;
}

.placeholder-recommendations{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    background-color: white;
    align-items: center;
    min-height: 45px;
}

.other-gifts{
    width: 100%;
    font-family: Karla,sans-serif;
    text-transform: capitalize;
    font-weight: bold;
    font-size: 1.3vw;
}

.other-gifts span{
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
}


/* card animation start */
.card-animation {
  display: block;
  width: 100%;
  position: relative;
  -webkit-perspective: 700;
  margin: 30px auto;
  cursor: pointer;
  padding-bottom: 100%;
}

.card-animation:hover .face {
  -webkit-transition: all 0.3s ease-out;
}

.card-animation .face {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: visible;
  -webkit-transition: all 0.5s ease-out;
  -webkit-transform-origin: 0 0;
}

.card-animation .front-top {
    -webkit-transform: rotateX(20deg);
    z-index: 3;
    -webkit-backface-visibility: hidden;
}


.card-animation .inner-top {
  -webkit-transform: rotateX(20deg);
  z-index: 2;
}

.card-animation .inner-top > img {
  -webkit-transform: rotateX(180deg);
}

.card-animation .inner-bottom {
  -webkit-transform: rotateX(0deg);
  z-index: 1;
}

.card-animation .inner-bottom > img{
    width: 100%;
}

.card-animation:hover .front-top,
.card-animation:hover .inner-top {
    -webkit-transform: rotateX(80deg);
}

/* vertical cards */

.card-animation .front-left {
    -webkit-transform: rotateY(-20deg);
    z-index: 3;
    -webkit-backface-visibility: hidden;
}


.card-animation .inner-left {
  -webkit-transform: rotateY(-20deg);
  z-index: 2;
}

.card-animation .inner-right {
  -webkit-transform: rotateY(0deg);
  z-index: 1;
}

.card-animation .inner-right > img{
    width: 100%;
}

.card-animation:hover .front-left,
.card-animation:hover .inner-left {
    -webkit-transform: rotateY(-80deg);
}
/* card animation end */

.date-button{
    margin-bottom: 5%;
    border-radius: 20px;
    border: 1px solid gray;
    padding: 2% 5%;
    color: gray;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.15vw;
    gap: 5px;
}

.date-button img{
    width: 10%;
}

.purple-link{
    cursor: pointer;
    color: #a01adb;
    text-decoration: underline;
    font-weight: 700;
    font-size: 1.5vw;
    width: 100%;
    text-align: left;
    margin-bottom: 1rem;
}

.message-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 11;
}

.message-modal .modal-container{
    width: auto;
    background-color: white;
    max-height: 90%;
    border-radius: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: auto;
    padding: 2% 3%;
    position: relative;
    max-width: 90%;
    gap: 5%;
}

.message-modal .modal-container .title{
    font-size: 2vw;
    color: #0f0c38;
    line-height: 1;
    width: 100%;
    font-weight: 700;
    margin-bottom: 2rem;
    text-align: center;
}

.message-modal .modal-container label{
    font-size: 1vw;
}

.message-modal .modal-container .input-container{
    display: flex;
    align-items: flex-start;
    margin-bottom: 2rem;
    width: 47%;
}

.message-modal .modal-container .input-container input{
    height: unset;
    margin-top: 0.3rem;
}

.message-modal .buttons{
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 5%;
}

.message-modal .x{
    z-index: 2;
    top: 6%;
    left: 89%;
    width: 3%;
    cursor: pointer;
    position: fixed;
}

.secondary-badge{
  position: absolute;
  bottom: 2%;
  right: 2%;
  background-color: #eff4fe;
  z-index: 2;
  border: 1px solid #F3EEFA;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 1% 3%;
  font-size: 1.1vw;
  font-weight: bold;
  color: #5981d9;
}

@media screen and (min-width: 767px){
.page5-content-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.cards-container{
    width: 80%;
}

.filters-container{
    width: 20%;
    overflow-y: scroll;
    overflow-x: hidden;
    position: sticky;
    top: 22vw;
    left: 0;
    height: 42vw;
    -webkit-transition: all .2s linear;
    transition: all .2s linear;
    padding: 1%;
}

.reset-button button{
    width: 100%;
}

.page5-container{
    padding: 0%;
}

.page5-header{
    position: sticky;
    top: 6vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    background-color: white;
    z-index: 1;
}

.sticking .main-title,.sticking .skip-card{
    margin-top: unset;
}

.sticking .main-title{
    font-size: 2vw;
}

.sticking .skip-card{
    margin-bottom: 3%;
}
.sticking .quick-tags-container{
    padding: 2px 8px;
    width: 100%;
    justify-content: flex-start;
}

.page5-header.sticking{
    box-shadow: 0px 2px 1px 0px #0003;
    flex-direction: row-reverse;
    align-items: center;
}

.sticking .empty-container{
    width: 27.5%;
}

.sticking .text-container{
    width: 45%;
}
}

@media screen and (max-width: 767px){
    .main-title{
        font-size: 5vw;
    }
    .main-subtitle{
        font-size: 3vw;
        text-align: center;
    }

    .cards-container{
        gap: 20px 4%;
        margin-top: 5%;
    }

    .cards-container li{
        width: 48%;
    }

    .card-image-container{
        width: 100%;
        flex-direction: row;
    }

    .card-image-container img{
        width: 50%;
        padding: 2.5%;
    }

    .card-title{
        font-size: 3.3vw;
    }

    .card-price{
        font-size: 3.3vw;
    }

    .card-desc{
        font-size: 3vw;
        padding-bottom: unset;
    }

    .write-message-container{
        flex-direction: column;
        position: absolute;
        background-color: white;
        border: none;
        padding: 5% 5%;
        bottom: 0;
        margin: unset;
        max-height: 90%;
        border-radius: 20px 20px 0 0;
        width: 100%;
        overflow-y: scroll;
    }

    .write-container{
        width: 100%;
        padding-bottom: 15%;
    }

    .purple-span{
        font-size: 3vw;
        line-height: 1.5;
    }

    .red-span{
        font-size: 3vw;
    }

    .from-container label,.message-container label{
        font-size: 3vw;
    }

    .from-container input,.write-container textarea{
        width: 100%;
        font-size: 4vw;
    }

    .from-container,.message-container{
        margin-bottom: 3%;
    }

    .blank-card-container{
        font-size: 3.5vw;
    }

    .complete-box{
        box-shadow: inset 0px 1px 0px #E6E8EC;
        position: absolute;
        bottom: 0%;
        width: 100%;
        text-align: center;
        background-color: white;
        left: 0;
        right: 0;
    }

    .complete-box .green{
        width: 90%;
        margin: 2% 0%;
    }

    .write-message-page{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0%;
        background-color: rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.5s;
        z-index: 43;
    }

    .write-message-page.expanded{
        height: 100%;
    }

    .separator-container{
        width: 100%;
        text-align: center;
        padding-bottom: 3%;
        margin-bottom: 3%;
        font-size: 4.8vw;
        font-weight: 700;
        box-shadow: inset 0px -1px 0px #e6e8ec;
        position: sticky;
        top: 0;
    }

    .card-container{
        height: 100%;
        justify-content: space-between;
    }

    .card-container .happybox-button.white{
        width: 100%;
        padding: 2%;
        margin-top: 0.5rem;
    }

    .content-header{
        padding-top: 5%;
    }

    .content-header .title{
        font-size: 6vw;
        margin-bottom: 0.5rem;
    }

    .content-header .subtitle{
        font-size: 3.5vw;
    }

    .content-header .subtitle span{
        color: #A01ADB;
        font-weight: bold;
    }

    .header-container{
        display: none;
    }

    .other-gifts{
        width: 100%;
        border-bottom: 0.5px solid gray;
        margin-bottom: 4%;
        font-size: 4vw;
        font-weight: bold;
    }
}
</style>